module.exports = __webpack_public_path__ + "assets/img/a5de-jm.svg";